import classNames from 'classnames';
import { capitalize } from 'lodash';
import React from 'react';
import { EngagementPlan } from '@redux/tasks/tasksTypes';
import EngagementPlanDefaultImage2 from 'assets/images/EngagementPlanDefaultImage2.png';
import { Text } from 'components/Typography';
import { Color } from 'utils/color';
import { countEngagementPlanTasks } from 'utils/taskUtils';
import style from './PreviewSection.scss';

type Props = {
  plan: EngagementPlan;
  containerStyle?: string;
};

export const PreviewSection: React.FC<Props> = ({ plan, containerStyle }) => {
  const title = capitalize(plan.title.trim());
  const tasksSpecification = countEngagementPlanTasks(plan);
  let description = `${plan.durationDays}-day${plan.durationDays === 1 ? '' : 's'} plan`;

  if (tasksSpecification.total) {
    if (tasksSpecification.recurring) {
      description += ` · ${tasksSpecification.recurring} recurring task${tasksSpecification.recurring === 1 ? '' : 's'}`;
    }

    description += ` (${tasksSpecification.total} total task${tasksSpecification.total === 1 ? '' : 's'})`;
  }

  return (
    <div className={classNames(style.container, containerStyle)}>
      <Text variant="nlg" weight={500}>
        Preview
      </Text>
      <div className={style.imagePreviewContainer} style={{ backgroundImage: `url(${plan.imageSource || EngagementPlanDefaultImage2})` }}>
        {plan.imageSource ? (
          <div className={classNames(style.titleShadow, style.titleWrapper)}>
            <Text variant="2xl" className={style.overlayTitle} color={Color.WHITE}>
              {title}
            </Text>
          </div>
        ) : (
          <div className={style.titleWrapper}>
            <Text variant="2xl">{title}</Text>
          </div>
        )}
      </div>

      <Text variant="md" color={Color.GRAY} className={style.metaText}>
        {description}
      </Text>
    </div>
  );
};
